import React, { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { Footer } from "../navigation/Footer";
import LoginUserSection from "../../template/login/LoginUserSection";
import { PageContainer } from "../Container/PageContainer";
import BrandVideoTemplate from "../../template/brand/BrandVideoTemplate";

const LoginPresent = ({
  svgRef,
  name,
  email,
  isSubmitting,
  handleLogin,
  handleWaitlist,
  setName,
  setEmail,
  customTabsContent,
}) => {
  return (
    <PageContainer>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={{ xs: 1.5, sm: 2.5, md: 3 }}
        sx={{
          width: "100%",
        }}
      >
        <Stack
          direction="column"
          alignItems="center"
          spacing={{ xs: 1, sm: 1.5 }}
          sx={{ width: "100%" }}
        >
          {/* 통합된 BrandVideoTemplate - 타이틀 섹션 포함 */}
          <Box sx={{ position: "relative", zIndex: 5, width: "100%" }}>
            {customTabsContent}
          </Box>

          <Box sx={{ position: "relative", zIndex: 20 }}>
            <LoginUserSection
              name={name}
              email={email}
              isSubmitting={isSubmitting}
              handleLogin={handleLogin}
              handleWaitlist={handleWaitlist}
              setName={setName}
              setEmail={setEmail}
            />
          </Box>
        </Stack>
      </Stack>
      <Box sx={{ position: "relative", zIndex: 20 }}>
        <Footer />
      </Box>
    </PageContainer>
  );
};

export default LoginPresent;
